// Module
var code = "<template>\n  <i class=\"ph-light icon-base\" class.bind=\"'ph-' + icon + ' ' + class\"></i>\n</template>\n";
// Exports
export default code;